/**
 * Picks the active brand ("deloitte" | "comply") and exposes its theme object.
 * NOTE: Organization-based auto-detection is deferred — for now everyone gets
 * the Comply theme by default regardless of stored preference or organization.
 * Change the brand at runtime with setActiveBrand("comply") / setActiveBrand("deloitte").
 */
import deloitteTheme from "./brands/deloitte/theme";
import complyTheme from "./brands/comply/theme";

const BRAND_STORAGE_KEY = "appBrand";
const brands = {
  deloitte: deloitteTheme,
  comply: complyTheme,
};

export function getActiveBrand() {
  // TODO: switch to organization-based detection later. For now, everyone gets Comply.
  return "comply";
}

export function getActiveBrandTheme() {
  return brands[getActiveBrand()];
}

export function setActiveBrand(brand) {
  if (!brands[brand]) return;
  window.localStorage.setItem(BRAND_STORAGE_KEY, brand);
  document.documentElement.setAttribute("data-brand", brand);
}

// Keep the `data-brand` attribute on <html> in sync so brands/deloitte/theme.css / brands/comply/theme.css apply.
if (typeof document !== "undefined") {
  document.documentElement.setAttribute("data-brand", getActiveBrand());
}

export const activeBrandTheme = getActiveBrandTheme();
